
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class BackButton extends Vue {
  @Prop({ default: 'Back to list' }) label!: string;

  @Prop({ default: false }) narrow!: string | boolean;

  @Prop({ default: false }) small!: string | boolean;

  get showLabel() {
    return this.narrow === false && !!this.label;
  }
}
